module.exports = __webpack_public_path__ + "static/media/matterhorn.1395b8e2.png";